import axios from 'axios'

export default (token = null) => {

  // Set baerer token
  if (token) {
    axios.defaults.headers.common.authorization = `Bearer ${token}`
  } else {
    delete axios.defaults.headers.common.authorization
  }
}


// WEBPACK FOOTER //
// ./src/api/setAuthorizationHeader.js